import T from '../../../../common/components/T';

export const transformProfuctGrid = (dataProduct) => {
    const thead = {
        data: [
            {
                name: 'name',
                title: <T textName='selectProductModal-grid-name' defaultStr='Название' page='/admin/user' />,
                type: 'text',
                nowrap: { td: true }
            },
            {
                name: 'price',
                title: <T textName='selectProductModal-grid-price' defaultStr='Цена' page='/admin/user' />,
                type: 'text',
                nowrap: { td: true }
            },
            {
                name: 'scores_price',
                title: <T textName='selectProductModal-grid-scores_price' defaultStr='Маркетингова цена' page='/admin/user' />,
                type: 'text',
                align: 'right',
                nowrap: { td: true }
            }
        ]
    };

    const newData = [];

    if (dataProduct?.data?.length > 0) {
        dataProduct?.data?.map((product) => {
            newData?.push({
                name: product?.name || '',
                price: product?.main_price?.price_for_partner_formatted || '0.00',
                scores_price: product?.main_price?.scores_for_client_formatted || '0.00',
                product: product
            });
        });
    }

    return {
        ...dataProduct,
        thead: thead,
        data: newData || []
    };
};
